// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__18FQx","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3MDpQ"};